import React, { createContext, useContext, useEffect, useState } from 'react';

const CustomContext = createContext();

export const CustomThemeProvider = ({children, institution}) => {
  const [theme, setTheme] = useState(institution || 'standard')
  useEffect(() => {
    const colors = {
      unimed: {primary: '#00975C', darkPrimary: '#017c4c'},
      aebel: {primary: '#203B7B', darkPrimary: '#1A3168'},
      standard: {primary: '#00975C', darkPrimary: '#017c4c'},
    }

    const selected = colors[theme] || colors.standard

    const root = window.document.documentElement
    root.style.setProperty('--color-primary', selected.primary)
    root.style.setProperty('--color-dark-primary', selected.darkPrimary)
  }, [theme]);

  return (
    <CustomContext.Provider value={{theme, setTheme}}>
      {children}
    </CustomContext.Provider>
  )
}

export const useTheme = () => useContext(CustomContext);